import React, { useState, useEffect } from 'react'
import { Col, Row } from 'antd'
import DiarioAlimentarIcon from '../assets/diarioIcon.png'
import barra1 from '../assets/barra_nutri1.png'
import barra2 from '../assets/barra_nutri2.png'
import barra3 from '../assets/barra_nutri3.png'
import barra4 from '../assets/barra_nutri4.png'
import barra5 from '../assets/barra_nutri5.png'
import barra6 from '../assets/barra_nutri6.png'
import barra7 from '../assets/barra_nutri7.png'
import barra8 from '../assets/barra_nutri8.png'
import barra9 from '../assets/barra_nutri9.png'
import {
  ArrowLeftOutlined,
  ClockCircleOutlined,
  UpOutlined,
  DownOutlined,
  SearchOutlined,
  BookOutlined,
  FilePdfOutlined,
  DeleteOutlined
} from '@ant-design/icons'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import './DiarioAlimentar.scss'
import { useNavigate } from 'react-router-dom'
import { getDoencas, getNutrientes, downloadRelatorioPdf, hasDiarioWeek, hasDiarioDay, deleteAlimentoDiario } from '../service/api';
import unidecode from 'unidecode';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  backgroundColor: '#ebebeb',
  color: '#555555',
  boxShadow: 24,
  p: 4,
};


const daysOfWeek = [
  'dom',
  'seg',
  'ter',
  'qua',
  'qui',
  'sex',
  'sab'
]

const formulasToIgnore = [
  "PKUMED A", "PKUMED B", "PKUMED C", "HCysMed A", "HCysMed B", "OACMED A", "OACMED B", "MSUDMED A", "MSUDMED B", "TYROMED A", "TYROMED B", "URCMED A", "URCMED B", "GACMED A", "GACMED B", "LEUMED A", "LEUMED B", "Anamix Infant MMA/PA", "Anamix Junior MMA/PA", "Anamix Infant TYR ", "Anamix Junior TYR", "Anamix Junior HCU ", "Amido Mix", "NuProba - substituto do ovo", "NuProba - substituto do queijo", "Baking Mix", "Crackers Original ", "Kicocoa", "Aproten Fusilli", "Aproten Penne", "Aproten Spaghetti", "Short Grain Rice", "Frosted Flakes ", "Frollini - biscoito doce", "Fusilli - massa seca", "Penne - massa seca", "Spaghetti - massa seca"
]

const DiarioAlimentar = () => {
  let navigate = useNavigate()
  const [dateSelect, setDateSelect] = useState('seg')
  const [cardOpenManha, setCardOpenManha] = useState(false)
  const [cardOpenAlmoco, setCardOpenAlmoco] = useState(false)
  const [cardOpenLanche1, setCardOpenLanche1] = useState(false)
  const [cardOpenLanche2, setCardOpenLanche2] = useState(false)
  const [cardOpenJanta, setCardOpenJanta] = useState(false)
  const [primeiraRef, setPrimeiraRef] = useState([])
  const [segundaRef, setSegundaRef] = useState([])
  const [terceiraRef, setTerceiraRef] = useState([])
  const [quartaRef, setQuartaRef] = useState([])
  const [quintaRef, setQuintaRef] = useState([])
  const [doeancasList, setDoeancasList] = useState([])
  const [nutrientesList, setNutrientesList] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [openModalDownloadPdf, setOpenModalDownloadPdf] = useState(false)
  const [openRecipeModal, setOpenRecipeModal] = useState(false)
  const [recipeSelected, setRecipeSelected] = useState([])
  const [doenca, setDoenca] = useState({});
  const [recConsumoDiario, setRecConsumoDiario] = useState({});
  const [description, setDescription] = useState('');
  const [viewDescription, setViewDescription] = useState(false);
  const [nutrientesSaved, setNutrientesSaved] = useState([])
  const [doencaSaved, setDoencaSaved] = useState({})
  const [nutrientesTable, setNutrientesTable] = useState([])
  const [loadingTable, setLoadingTable] = useState(true)
  const [realizouCadastroDoenca, setRealizouCadastroDoenca] = useState(false)
  const [recipeName, setRecipeName] = useState("")
  const [dataRelatorio, setDataRelatorio] = useState([]);
  const [formulasAlert, setFormulasAlert] = useState({})
  const [userId, setUserId] = useState("")
  const [weekId, setWeekId] = useState("")
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  useEffect(() => {
    // localStorage.removeItem('lembretes')
    // localStorage.removeItem('nutrientes')
    setLoadingTable(true)
    setWeekId(localStorage.getItem("diarioWeek"))
    const userId = localStorage.getItem('userId')
    if (!userId) {
      navigate('/login', { replace: true })
    }
    setUserId(userId)
    var curr = new Date;
    setDateSelect(daysOfWeek[curr.getDay()])

    // get current date
    var first = (curr.getDate() - curr.getDay()); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var firstday = new Date(curr.setDate(first)).toISOString();
    var lastday = new Date(curr.setDate(last)).toISOString();
    var date = new Date;

    var doenca = JSON.parse(localStorage.getItem('doenca'))
    setDoencaSaved(doenca)
    if (doenca != null)
      setRealizouCadastroDoenca(true)

    var nutrientes = JSON.parse(localStorage.getItem('nutrientes'))
    setNutrientesSaved(nutrientes)

    var lembretes = JSON.parse(localStorage.getItem("lembretes"))
    var alerts = {
      "09:00": [],
      "12:00": [],
      "14:00": [],
      "17:30": [],
      "21:00": [],
    }
    if (lembretes != null) {
      lembretes.map(function (item, i) {
        if (item.ativado && item.horario) {
          const aux = alerts[item.horario]
          var horario = item.horario
          if (item.horarioConsumo)
            horario = item.horarioConsumo
          aux.push(item.formula + " às " + horario + "h - " + item.quantidade + "g")
          alerts[item.horario] = aux
        }
      })
    }

    setFormulasAlert(alerts)

    const hasDiario = async () => {
      let weekIdResp;
      await hasDiarioWeek(userId, firstday, lastday)
        .then(async response => {
          if (response) {
            localStorage.setItem("diarioWeek", response.week_id)
            weekIdResp = response.week_id
            setWeekId(response.week_id)
            await hasDiarioDay(userId, date.toISOString(), weekIdResp, daysOfWeek[date.getDay()])
              .then(async response => {
                if (response) {
                  if (response.length > 0) {
                    console.log("MAKE TABLE")
                    response.map(function (alimento, index) {
                      if (alimento["ref_id"] == "0") {
                        let aux = primeiraRef
                        aux.push(alimento)
                        setPrimeiraRef(aux)
                      } else if (alimento["ref_id"] == "1") {
                        let aux = segundaRef
                        aux.push(alimento)
                        setSegundaRef(aux)
                      } else if (alimento["ref_id"] == "2") {
                        let aux = terceiraRef
                        aux.push(alimento)
                        setTerceiraRef(aux)
                      } else if (alimento["ref_id"] == "3") {
                        let aux = quartaRef
                        aux.push(alimento)
                        setQuartaRef(aux)
                      } else if (alimento["ref_id"] == "4") {
                        let aux = quintaRef
                        aux.push(alimento)
                        setQuintaRef(aux)
                      }
                    })
                  }
                  const table = await makeNutrientesTable(primeiraRef, segundaRef, terceiraRef, quartaRef, quintaRef, nutrientes)
                  console.log(table)
                  setNutrientesTable(table)
                  setLoadingTable(false)


                }
              })
              .catch(function (error) {
                console.log(error)
                //create week
              });
          }
        })
        .catch(function (error) {
          console.log(error)
        });




    }
    hasDiario()

    // var prim = JSON.parse(localStorage.getItem(dateSelect + "0"))
    // setPrimeiraRef(prim)
    // var seg = JSON.parse(localStorage.getItem(dateSelect + "1"))
    // setSegundaRef(seg)
    // var ter = JSON.parse(localStorage.getItem(dateSelect + "2"))
    // setTerceiraRef(ter)
    // var qua = JSON.parse(localStorage.getItem(dateSelect + "3"))
    // setQuartaRef(qua)
    // var qui = JSON.parse(localStorage.getItem(dateSelect + "4"))
    // setQuintaRef(qui)
  }, [])

  // const clickChangeCardState = (ref) => {
  //   console.log('OPEN')
  //   let newState = cardOpen;
  //   newState[ref] = !newState[ref];
  //   console.log(newState)
  //   setCardOpen(newState);
  // }

  const onClickCalendar = async (day) => {
    const date = new Date
    const ref1 = []
    const ref2 = []
    const ref3 = []
    const ref4 = []
    const ref5 = []
    const dayonWeeks = {
      'dom': 0,
      'seg': 1,
      'ter': 2,
      'qua': 3,
      'qui': 4,
      'sex': 5,
      'sab': 6
    }
    let dateSelected = (date.getDate() - date.getDay()) + dayonWeeks[day];
    dateSelected = new Date(date.setDate(dateSelected)).toISOString();
    await hasDiarioDay(userId, dateSelected, weekId, day)
      .then(response => {
        if (response) {
          if (response.length > 0) {
            response.map(function (alimento, index) {
              if (alimento["ref_id"] == "0") {
                ref1.push(alimento)
              } else if (alimento["ref_id"] == "1") {
                ref2.push(alimento)
              } else if (alimento["ref_id"] == "2") {
                ref3.push(alimento)
              } else if (alimento["ref_id"] == "3") {
                ref4.push(alimento)
              } else if (alimento["ref_id"] == "4") {
                ref5.push(alimento)
              }
            })
          }
          setPrimeiraRef(ref1)
          setSegundaRef(ref2)
          setTerceiraRef(ref3)
          setQuartaRef(ref4)
          setQuintaRef(ref5)
          var nutrientes = JSON.parse(localStorage.getItem('nutrientes'))
          const table = makeNutrientesTable(ref1, ref2, ref3, ref4, ref5, nutrientes)
          setNutrientesTable(table)
          setLoadingTable(false)
        }
      })
      .catch(function (error) {
        console.log(error)
        //create week
      });
    setDateSelect(day)
  }

  const onClickBack = () => {
    navigate('/', { replace: true })
  }

  const onClickSearch = (path) => {

    navigate(path, { replace: true });
  }

  const hanldeOpenModalDownloadPdf = () => {
    setOpenModalDownloadPdf(true);
  }

  const handleCloseModalDownloadPdf = () => setOpenModalDownloadPdf(false);

  const onClickDownloadPdf = async () => {
    const month = dataRelatorio.$d.getMonth() + 1
    const newDate = dataRelatorio.$y + "-" + month + "-" + dataRelatorio.$D
    await downloadRelatorioPdf(newDate, userId, nutrientesSaved).then(response => {
      const fileLink = document.createElement('a');
      fileLink.href = response.fileURL;
      const fileName = response.fileName;
      fileLink.setAttribute('download', fileName);
      fileLink.setAttribute('target', '_blank');
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }).catch(error => {
      console.log(error)
      setErrorMessage(error)
      setOpen(true)
    });
  }

  const loadDoencas = async () => {
    await getDoencas()
      .then(response => {
        setDoeancasList(response)
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  const loadNutrientes = async (id) => {
    await getNutrientes(id)
      .then(response => {
        setNutrientesList(response)
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  const handleOpenModal = () => {
    setOpenModal(true);
    loadDoencas();
  }
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenRecipeModal = (dishList) => {
    setRecipeName("")
    setOpenRecipeModal(true);
    setRecipeSelected(dishList);
  }
  const handleCloseRecipeModal = () => setOpenRecipeModal(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const fullDescription = () => setViewDescription(!viewDescription)

  const handleChange = (event) => {
    setDoenca(event.target.value);
    setDescription(event.target.value.descricao)
    loadNutrientes(event.target.value.doencaid)
  };

  const handleChangeRecomendacao = (value, item) => {
    let recs = recConsumoDiario
    recs[item.nutrienteid] = value
    setRecConsumoDiario(recs)
  };

  const redirectToDiagnostico = () => {
    navigate('/cadastrar-exames', { replace: true })
  }

  const handleChangeRecipe = (value) => {
    setRecipeName(value)
  };

  const handleChangeDate = (newValue) => {
    setDataRelatorio(newValue)
  }

  const deleteAlimento = async (itemToDelete) => {
    await deleteAlimentoDiario(itemToDelete.diario_alimento_id)
      .then(response => {
        window.location.reload()
      })
      .catch(function (error) {
        console.log(error)
        setErrorMessage("Erro ao deletar alimento, tente novamente")
        setOpen(true)
      });
    console.log(itemToDelete)
  }

  const saveDoenca = () => {
    let doencaData = {
      'doencaId': doenca.doencaid,
      'nome': doenca.nome
    }

    localStorage.setItem('doenca', JSON.stringify(doencaData))

    var nutrientesData = nutrientesList.map(function (item, i) {
      return {
        'nutrienteid': item.nutrienteid,
        'quantidade': recConsumoDiario[item.nutrienteid],
        'nome': item.nome
      }
    })

    localStorage.setItem('nutrientes', JSON.stringify(nutrientesData))
    handleCloseModal()
    window.location.reload()
  }

  const calculaConsumido = (nutValor, nutConsumido) => {

    return ((parseFloat(nutValor) * parseFloat(nutConsumido)) / 100)
  }

  const makeNutrientesTable = (ref1, ref2, ref3, ref4, ref5, nutrientes) => {

    var calConsumida = 0
    let table = nutrientes

    table.map(function (nut, index) {
      table[index].consumido = 0
    })

    if (ref1) {
      ref1.map(function (item, i) {
        console.log(item)
        if (!formulasToIgnore.includes(item.nome)) {
          if (!isNaN(parseFloat(item['energia']))) {
            calConsumida = calConsumida + calculaConsumido(parseFloat(item['energia']), parseFloat(item.consumido))
          }

          table.map(function (nut, index) {
            if (nut.nome.toLowerCase() == "fenilalanina") {
              let consumido

              if (table[index].consumido) {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = table[index].consumido + calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            } else {
              let consumido
              if (table[index].consumido) {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = (table[index].consumido) + calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
              } else {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            }
          })
        }
      })
    }
    if (ref2)
      ref2.map(function (item, i) {
        if (!formulasToIgnore.includes(item.nome)) {
          if (!isNaN(parseFloat(item['energia']))) {
            calConsumida = calConsumida + calculaConsumido(parseFloat(item['energia']), parseFloat(item.consumido))
          }

          table.map(function (nut, index) {

            if (nut.nome.toLowerCase() == "fenilalanina") {
              let consumido

              if (table[index].consumido) {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = table[index].consumido + calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            } else {
              let consumido
              if (table[index].consumido) {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = table[index].consumido + calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            }
          })
        }
      })

    if (ref3)
      ref3.map(function (item, i) {
        if (!formulasToIgnore.includes(item.nome)) {
          if (!isNaN(parseFloat(item['energia']))) {
            calConsumida = calConsumida + calculaConsumido(parseFloat(item['energia']), parseFloat(item.consumido))
          }

          table.map(function (nut, index) {
            if (nut.nome.toLowerCase() == "fenilalanina") {
              let consumido

              if (table[index].consumido) {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = table[index].consumido + calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            } else {
              let consumido
              if (table[index].consumido) {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = table[index].consumido + calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            }
          })
        }
      })

    if (ref4)
      ref4.map(function (item, i) {
        if (!formulasToIgnore.includes(item.nome)) {
          if (!isNaN(parseFloat(item['energia']))) {
            calConsumida = calConsumida + calculaConsumido(parseFloat(item['energia']), parseFloat(item.consumido))
          }

          table.map(function (nut, index) {
            if (nut.nome.toLowerCase() == "fenilalanina") {
              let consumido

              if (table[index].consumido) {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = table[index].consumido + calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido
            } else {
              let consumido
              if (table[index].consumido) {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = table[index].consumido + calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = 0
              }


              table[index].consumido = consumido
            }
          })
        }
      })

    if (ref5)
      ref5.map(function (item, i) {
        if (!formulasToIgnore.includes(item.nome)) {
          if (!isNaN(parseFloat(item['energia']))) {
            calConsumida = calConsumida + calculaConsumido(parseFloat(item['energia']), parseFloat(item.consumido))
          }

          table.map(function (nut, index) {
            if (nut.nome.toLowerCase() == "fenilalanina") {
              let consumido

              if (table[index].consumido) {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = table[index].consumido + calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item['fenilanina'])))
                  consumido = calculaConsumido(parseFloat(item['fenilanina']), parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            } else {
              let consumido
              if (table[index].consumido) {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = table[index].consumido + calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = table[index].consumido
              } else {
                if (!isNaN(parseFloat(item[unidecode(nut.nome.toLowerCase())])))
                  consumido = calculaConsumido(item[unidecode(nut.nome.toLowerCase())], parseFloat(item.consumido))
                else
                  consumido = 0
              }

              table[index].consumido = consumido

            }
          })
        }
      })

    table.push({
      consumido: calConsumida,
      nome: "Calorias",
      quantidade: " - "
    })

    setNutrientesTable(table)

    return table
  }

  const saveRecipe = () => {
    const key = "recipes"
    var recipes = localStorage.getItem(key)
    if (recipes) {
      recipes = JSON.parse(recipes)
      const newRecipe = {
        name: recipeName,
        dishs: recipeSelected
      }
      const value = recipes.concat(newRecipe)
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      const newRecipe = [{
        name: recipeName,
        dishs: recipeSelected
      }]
      localStorage.setItem(key, JSON.stringify(newRecipe))
    }
    handleCloseRecipeModal()
  }

  return (
    <div className="diario">
      <Row>
        <Col span={24} className="diario__header">
          <ArrowLeftOutlined className="diario__icons" onClick={onClickBack} />
          <img src={DiarioAlimentarIcon} alt="" className="diario__logo" />
          <p className="diario__title">Diário Alimentar</p>
        </Col>
      </Row>
      <div className="diario__calendar">
        <div
          style={{
            backgroundColor: dateSelect == 'dom' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('dom')}
        >
          <p>dom</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'seg' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('seg')}
        >
          <p>seg</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'ter' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('ter')}
        >
          <p>ter</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'qua' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('qua')}
        >
          <p>qua</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'qui' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('qui')}
        >
          <p>qui</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'sex' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('sex')}
        >
          <p>sex</p>
        </div>
        <div
          style={{
            backgroundColor: dateSelect == 'sab' ? '#31887b' : '#29AF9C',
          }}
          className="diario__date"
          onClick={() => onClickCalendar('sab')}
        >
          <p>sab</p>
        </div>
      </div>

      <div className="diario__bodyTitle">
        <p>Refeições</p>
      </div>
      <div>
        <div className="diario__card">
          <div className="diario__cardHeader" onClick={() => setCardOpenManha(!cardOpenManha)}>
            <div className='diario__cardIcon'><ClockCircleOutlined /></div>
            <div className='diario__cardTitle'>
              <p>Café da Manhã</p>
              <p style={{ marginTop: -10 }}>09:00</p>
            </div>
            <div className='diario__cardCollapse'>
              {
                cardOpenManha ?
                  <DownOutlined />
                  :
                  <UpOutlined />
              }
            </div>
          </div>
          {cardOpenManha && (
            <div>
              <hr className="diario__solid" />
              {
                primeiraRef &&
                primeiraRef.map(function (item, i) {
                  return (
                    <div className='diario__foodList'>- <b>{item.nome}</b>: {item.consumido}g <DeleteOutlined style={{ marginLeft: 20, color: "#ca0000" }} onClick={() => deleteAlimento(item)} /></div>
                  )
                })
              }

              {
                formulasAlert["09:00"].map(function (item, i) {
                  return (
                    <Alert severity="warning" style={{ marginBottom: 10 }}>Lembre-se: consumir fórmula {item}</Alert>
                  )
                })
              }

              <div className='diario__cardSearch' onClick={() => onClickSearch(`/consultar-alimentos/${dateSelect}/0`)}>
                <SearchOutlined style={{ marginRight: 10 }} />
                Inserir Alimentos
              </div>


              <div className='diario__cardSearch' onClick={() => onClickSearch(`/calcular-receitas/${dateSelect}/0`)}>
                <BookOutlined style={{ marginRight: 10 }} />
                Inserir Receita
              </div>


            </div>
          )}
        </div>
        <div className="diario__card">
          <div className="diario__cardHeader" onClick={() => setCardOpenAlmoco(!cardOpenAlmoco)}>
            <div className='diario__cardIcon'><ClockCircleOutlined /></div>
            <div className='diario__cardTitle' style={{ marginRight: 20 }}>
              <p>Almoço</p>
              <p style={{ marginTop: -10 }}>12:00</p>
            </div>
            <div className='diario__cardCollapse'>
              {
                cardOpenAlmoco ?
                  <DownOutlined />
                  :
                  <UpOutlined />
              }
            </div>
          </div>
          {cardOpenAlmoco && (
            <div>
              <hr className="diario__solid" />
              {
                segundaRef &&
                segundaRef.map(function (item, i) {
                  return (
                    <div className='diario__foodList'>- <b>{item.nome}</b>: {item.consumido}g <DeleteOutlined style={{ marginLeft: 20, color: "#ca0000" }} onClick={() => deleteAlimento(item)} /></div>
                  )
                })
              }

              {
                formulasAlert["12:00"].map(function (item, i) {
                  return (
                    <Alert severity="warning" style={{ marginBottom: 10 }}>Lembre-se: consumir fórmula {item}</Alert>
                  )
                })
              }

              <div className='diario__cardSearch' onClick={() => onClickSearch(`/consultar-alimentos/${dateSelect}/1`)}>
                <SearchOutlined style={{ marginRight: 10 }} />
                Inserir Alimentos
              </div>
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/calcular-receitas/${dateSelect}/1`)}>
                <BookOutlined style={{ marginRight: 10 }} />
                Inserir Receita
              </div>

            </div>
          )}
        </div>
        <div className="diario__card">
          <div className="diario__cardHeader" onClick={() => setCardOpenLanche1(!cardOpenLanche1)}>
            <div className='diario__cardIcon'><ClockCircleOutlined /></div>
            <div className='diario__cardTitle'>
              <p>Lanche 1</p>
              <p style={{ marginTop: -10 }}>14:00</p>
            </div>
            <div className='diario__cardCollapse'>
              {
                cardOpenLanche1 ?
                  <DownOutlined />
                  :
                  <UpOutlined />
              }
            </div>
          </div>
          {cardOpenLanche1 && (
            <div>
              <hr className="diario__solid" />
              {
                terceiraRef &&
                terceiraRef.map(function (item, i) {
                  return (
                    <div className='diario__foodList'>- <b>{item.nome}</b>: {item.consumido}g <DeleteOutlined style={{ marginLeft: 20, color: "#ca0000" }} onClick={() => deleteAlimento(item)} /></div>
                  )
                })
              }
              {
                formulasAlert["14:00"].map(function (item, i) {
                  return (
                    <Alert severity="warning" style={{ marginBottom: 10 }}>Lembre-se: consumir fórmula {item}</Alert>
                  )
                })
              }
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/consultar-alimentos/${dateSelect}/2`)}>
                <SearchOutlined style={{ marginRight: 10 }} />
                Inserir Alimentos
              </div>
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/calcular-receitas/${dateSelect}/2`)}>
                <BookOutlined style={{ marginRight: 10 }} />
                Inserir Receita
              </div>

            </div>
          )}
        </div>
        <div className="diario__card">
          <div className="diario__cardHeader" onClick={() => setCardOpenLanche2(!cardOpenLanche2)}>
            <div className='diario__cardIcon'><ClockCircleOutlined /></div>
            <div className='diario__cardTitle'>
              <p>Lanche 2</p>
              <p style={{ marginTop: -10 }}>17:30</p>
            </div>
            <div className='diario__cardCollapse'>
              {
                cardOpenLanche2 ?
                  <DownOutlined />
                  :
                  <UpOutlined />
              }
            </div>
          </div>
          {cardOpenLanche2 && (
            <div>
              <hr className="diario__solid" />
              {
                quartaRef &&
                quartaRef.map(function (item, i) {
                  return (
                    <div className='diario__foodList'>- <b>{item.nome}</b>: {item.consumido}g <DeleteOutlined style={{ marginLeft: 20, color: "#ca0000" }} onClick={() => deleteAlimento(item)} /></div>
                  )
                })
              }
              {
                formulasAlert["17:30"].map(function (item, i) {
                  return (
                    <Alert severity="warning" style={{ marginBottom: 10 }}>Lembre-se: consumir fórmula {item}</Alert>
                  )
                })
              }
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/consultar-alimentos/${dateSelect}/3`)}>
                <SearchOutlined style={{ marginRight: 10 }} />
                Inserir Alimentos
              </div>
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/calcular-receitas/${dateSelect}/3`)}>
                <BookOutlined style={{ marginRight: 10 }} />
                Inserir Receita
              </div>

            </div>
          )}
        </div>
        <div className="diario__card">
          <div className="diario__cardHeader" onClick={() => setCardOpenJanta(!cardOpenJanta)}>
            <div className='diario__cardIcon'><ClockCircleOutlined /></div>
            <div className='diario__cardTitle'>
              <p>Jantar</p>
              <p style={{ marginTop: -10 }}>21:00</p>
            </div>
            <div className='diario__cardCollapse'>
              {
                cardOpenJanta ?
                  <DownOutlined />
                  :
                  <UpOutlined />
              }
            </div>
          </div>
          {cardOpenJanta && (
            <div>
              <hr className="diario__solid" />
              {
                quintaRef &&
                quintaRef.map(function (item, i) {
                  return (
                    <div className='diario__foodList'>- <b>{item.nome}</b>: {item.consumido}g <DeleteOutlined style={{ marginLeft: 20, color: "#ca0000" }} onClick={() => deleteAlimento(item)} /></div>
                  )
                })
              }
              {
                formulasAlert["21:00"].map(function (item, i) {
                  return (
                    <Alert severity="warning" style={{ marginBottom: 10 }}>Lembre-se: consumir fórmula {item}</Alert>
                  )
                })
              }
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/consultar-alimentos/${dateSelect}/4`)}>
                <SearchOutlined style={{ marginRight: 10 }} />
                Inserir Alimentos
              </div>
              <div className='diario__cardSearch' onClick={() => onClickSearch(`/calcular-receitas/${dateSelect}/4`)}>
                <BookOutlined style={{ marginRight: 10 }} />
                Inserir Receita
              </div>

            </div>
          )}
        </div>
      </div>
      {
        realizouCadastroDoenca ?
          !loadingTable ?
            <div>
              <div className="diario__nutriRows">
                <div className="diario__nutriCol">
                  <h4>Nutriente</h4>
                </div>
                <div className="diario__nutriCol">
                  <h4>Recomendado</h4>
                </div>
                <div className="diario__nutriCol">
                  <h4>Consumido</h4>
                </div>
                {
                  nutrientesTable.map(function (item, i) {
                    console.log(item.nome + " ----")
                    console.log((item.consumido / Number(item.quantidade)) * 100)
                    return (
                      <>
                        {
                          item.nome == "Proteína" ?
                            <div style={{ minWidth: "100vw" }}>
                              <div className="diario__nutriCol">
                                {item.nome == "Proteína" ? "Proteína Natural" : item.nome}
                              </div>
                              <div className="diario__nutriCol">
                                {item.nome == "Proteína" ? item.quantidade + "g" : item.nome == "Calorias" ? " - " : item.quantidade + "mg"}
                              </div>
                              <div className="diario__nutriCol">
                                {item.nome == "Proteína" ? item.consumido.toFixed(2) + "g" : item.nome == "Calorias" ? item.consumido + "kcal" : item.consumido + "mg"}
                              </div>
                              {
                                ((item.consumido / Number(item.quantidade)) * 100) <= 5 ?
                                  <div>
                                    <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                    <img src={barra9} alt="" className="diario__grafico" />
                                  </div>
                                  : ((item.consumido / Number(item.quantidade)) * 100) > 5 && ((item.consumido / Number(item.quantidade)) * 100) <= 20 ?
                                    <div>
                                      <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                      <img src={barra8} alt="" className="diario__grafico" />
                                    </div>
                                    : ((item.consumido / Number(item.quantidade)) * 100) > 20 && ((item.consumido / Number(item.quantidade)) * 100) <= 30 ?
                                      <div>
                                        <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                        <img src={barra7} alt="" className="diario__grafico" />
                                      </div>
                                      : ((item.consumido / Number(item.quantidade)) * 100) > 30 && ((item.consumido / Number(item.quantidade)) * 100) <= 40 ?
                                        <div>
                                          <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                          <img src={barra6} alt="" className="diario__grafico" />
                                        </div>
                                        : ((item.consumido / Number(item.quantidade)) * 100) > 40 && ((item.consumido / Number(item.quantidade)) * 100) <= 50 ?
                                          <div>
                                            <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                            <img src={barra5} alt="" className="diario__grafico" />
                                          </div>
                                          : ((item.consumido / Number(item.quantidade)) * 100) > 50 && ((item.consumido / Number(item.quantidade)) * 100) <= 60 ?
                                            <div>
                                              <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                              <img src={barra4} alt="" className="diario__grafico" />
                                            </div>
                                            : ((item.consumido / Number(item.quantidade)) * 100) > 60 && ((item.consumido / Number(item.quantidade)) * 100) <= 80 ?
                                              <div>
                                                <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                                <img src={barra3} alt="" className="diario__grafico" />
                                              </div>
                                              : ((item.consumido / Number(item.quantidade)) * 100) > 80 && ((item.consumido / Number(item.quantidade)) * 100) <= 95 ?
                                                <div>
                                                  <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                                  <img src={barra2} alt="" className="diario__grafico" />
                                                </div>
                                                : ((item.consumido / Number(item.quantidade)) * 100) > 95 ?
                                                  <div>
                                                    <p>{Number(((item.consumido / item.quantidade) * 100)).toFixed(2)}%</p>
                                                    <img src={barra1} alt="" className="diario__grafico" />
                                                  </div>
                                                  :
                                                  <></>


                              }
                            </div>
                            :
                            <div>

                            </div>
                          // <div style={{ minWidth: "100vw" }}>
                          //   <div className="diario__nutriCol">
                          //     {item.nome == "Proteína" ? "Proteína Natural" : item.nome}
                          //   </div>
                          //   <div className="diario__nutriCol">
                          //     {item.nome == "Proteína" ? item.quantidade + "g" : item.nome == "Calorias" ? " - " : item.quantidade + "mg"}
                          //   </div>
                          //   <div className="diario__nutriCol">
                          //     {item.nome == "Proteína" ? item.consumido + "g" : item.nome == "Calorias" ? item.consumido + "kcal" : item.consumido + "mg"}
                          //   </div>
                          // </div>
                        }
                      </>
                    )
                  })
                }
              </div>
              <div className='diario__cardSearch' onClick={() => hanldeOpenModalDownloadPdf()}>
                <FilePdfOutlined style={{ marginRight: 10 }} />
                Exportar Relatório de Consumo
              </div>
            </div>
            :
            <CircularProgress color="success" />
          :
          <div>
            <div className='diario__warn'>
              Realizar cadastro de diagnóstico para acompanhar consumo diário
            </div>
            <div className='diario__cardSearch' onClick={() => redirectToDiagnostico()}>
              Cadastro de Diagnóstico
            </div>
          </div>

        // <CircularProgress color="success" />

      }
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Cadastro de Diagnóstico</h2>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-standard-label">Diagnóstico</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={doenca}
              onChange={handleChange}
              label="Doença"
            >
              {
                doeancasList.map(function (item, i) {
                  return (
                    <MenuItem value={item}>
                      <em>{item.nome}</em>
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          {
            doenca.descricao != undefined &&
            <div onClick={fullDescription} style={{ fontSize: 12, marginTop: -10 }}> {viewDescription ? <p>{description}</p> : <p>{description.substring(0, 103)}... <br></br> <b>ver mais</b></p>}</div>
          }
          {
            JSON.stringify(doenca) != '{}' &&

            <div>
              <h4 style={{ marginBottom: -10 }}>Nutrientes Controlados:</h4>
              {
                nutrientesList.map(function (item, i) {
                  return (
                    <div>
                      <h5>{item.nome}</h5>
                      <TextField id={item.nutrienteid} onChange={(event) => handleChangeRecomendacao(event.target.value, item)} label="Recomendação diária" type="number" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 120 }} />g
                    </div>
                  )
                })
              }
            </div>
          }
          <div className='diario__cardInserirDoenca' onClick={() => saveDoenca()}>
            Salvar
          </div>
        </Box>
      </Modal>
      <Modal
        open={openRecipeModal}
        onClose={handleCloseRecipeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Cadastro de Receita</h2>
          <div>
            <TextField id='recipe' onChange={(event) => handleChangeRecipe(event.target.value)} label="Nome da Receita" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 120 }} />
          </div>
          <div className='diario__cardInserirDoenca' onClick={() => saveRecipe()}>
            Salvar
          </div>
        </Box>
      </Modal>
      <Modal
        open={openModalDownloadPdf}
        onClose={handleCloseModalDownloadPdf}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h3>Selecione um dia para exportar o relatório</h3>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              label="Data"
              inputFormat="DD/MM/YYYY"
              value={dataRelatorio}
              onChange={handleChangeDate}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <div className='diario__cardSearch' style={{ marginTop: 30 }} onClick={() => onClickDownloadPdf()}>
            <FilePdfOutlined style={{ marginRight: 10 }} />
            Baixar Relatório
          </div>
          <a href="" download=""></a>
        </Box>
      </Modal>
    </div>
  )
}

export default DiarioAlimentar
